export default __webpack_public_path__ + "static/media/recharge_img.6c3e499c.png";